import { Component } from '@angular/core';
import {LayoutService} from "../../../../shared/services/layout.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-customize-table',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './customize-table.component.html',
  styleUrl: './customize-table.component.scss'
})
export class CustomizeTableComponent {
  constructor(public layoutServices :LayoutService , private modalService: NgbModal){}

  customizes(val: string) {
    this.layoutServices.customize = val;
  }

  openModal(popup: any) {
    this.modalService.open(popup, { backdropClass: 'dark-modal', centered: true });
  }
}
